module.exports = __webpack_public_path__ + "static/piclife_about2-c9604cfea43ab91b590406f4fc5050d1.png";